<template>
  <div class="about">
    <Header/>
      <div class="aprovados">
        <div id="fotos_aprovados">
          <!-- <b-row>
            <b-col md="6">
              <h5 class="circle">19 aprovados na MEDICINA UNILUS 2019</h5>
            </b-col>
            <b-col md="6">
              <h5 class="circle">10+ aprovações em MEDICINA PÚBLICA em 2019 e 2020</h5>
            </b-col>
            <b-col md="6">
              <h5 class="circle" v-if="show">51 aprovados MEDICINA UNIMES 2020</h5>
            </b-col>
            <b-col md="6">
              <transition name="bounce">
                <h5 v-if="show" class="circle">97% de aprovação em UNIVERSIDADE PÚBLICA para demais cursos </h5>
              </transition><br>
            </b-col>
          </b-row> -->
          <h4 class="titulo_circle">Conheça alguns aprovados</h4><br>
          <b-row style="margin:0px">
            <b-col md="2" v-for="data in dados">
              <div class="imagem">
                <img :src="data.imagem" class="img_aprov">
              </div>
              <p class="txt_aprovados">{{data.nome_aprovado}} ♥</p>
              <p class="txt_aprovados">{{data.legenda}}</p>
            </b-col>
          </b-row>
          </div>
      </div>
      <div class="body">
        <div class="sobre">
          <h2 id="p_depoimentos">Depoimentos</h2>
          <!-- <p> Aluno Guilherme Nobre de Oliveira, aprovado em medicina na USP, UNICAMP, e UFPR. </p> -->
          <div id="localizacao">
            <div class="img_location">
            <my-video :sources="video1.sources" :options="video1.options" style="width:70%"></my-video>
            </div>
            <div class="img_location">
            <my-video :sources="video2.sources" :options="video2.options" style="width:70%"></my-video>
            </div>
          </div> <hr>
          <div id="img_aprovados">
            <h1 class="msgs">"Se você pode sonhar, você pode fazer" - Walt Disney</h1>
            <img alt="aprovados" id="imag" src="../assets/img/alunos aprovados.jpg">
          </div>
        </div>
      </div>
    <Footer/>
  </div>
</template>

<script>
import myVideo from 'vue-video'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  name: 'aprovados',
  mounted () {
    this.change(),
    this.pegar_aprovados()
  },
  data () {
    return {
      show: false,
      dados: [],
      video1: {
        sources: [{
          src: 'http://cursinhosapiencia.com.br/img/depoimento.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6
        }
      },
      video2: {
        sources: [{
          src: 'http://cursinhosapiencia.com.br/img/depoimento2.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6
        }
      }
    }
  },
  components: {
    Header,
    Footer,
    myVideo
  },
  methods: {
    pegar_aprovados () {
      this.axios.post('https://cursinhosapiencia.com.br/pegar_aprovados.php')
      .then(res=>{
        this.dados = res.data;
        this.mostrar=true
      });
    },
    change () {
      this.show = true
    },
    showImages () {
      for (let i = 1; i <= 26; ++i){
        setTimeout(function() {
          let divs=document.getElementById('img'+i)
          divs.style.display = 'inline'
        }, i*300);
      }
    }
  }
}
</script>

<style>
@import "../assets/style_padrao.css";
  .__cov-video-container {
    width: 100%!important;
    height: 100%!important;
  }
  #p_depoimentos{
    text-align:center;
    margin-bottom:4%;
  }
  h2#p_depoimentos:after{
    content: '';
    display: block;
    height: 2px;
    width: 100px;
    margin: 20px auto 0;
    background: yellowgreen;
  }
  h5.circle:after {
    content: '';
    display: block;
    height: 2px;
    width: 100px;
    margin: 20px auto 0;
    background: yellowgreen;
  }
  .txt_aprovados{
    color:white;
    justify-content: center;
    display: flex;
  }
  .img_aprov{
    width: 100%;
    border-radius: 50%;
  }
  .aprov{
    word-break: break-all!important;
    text-align: left;
    width: 50%;
  }
  .depoimentos{
  }
  .balao2{
    margin: 0 auto;
    background: #7e57c2;
    font-family: 'open sans';
    font-size: 0.85em;
    line-height: 1.6em;
    border-radius: 15px;
    height: auto;
    color: #fff;
    padding: 20px;
    position: relative;
    margin-top: 30px;
  }
  .balao2:after{
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #7e57c2;
    bottom:20px;
    top: -20px; /*localização. Experimente alterar para 'bottom'*/
    left: 20%;
  }
  h4{
    text-align: center;
  }
  .img_aprovado{
    justify-content: center;
    display: flex;
  }
  .fotos_sapi{
    justify-content: center;
    display: flex;
    background:purple;
  }
   .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
  }
  .circle{
      color:white;
  }
  /* Fading animation */
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: 1.5s;
    animation-name: fade;
    animation-duration: 1.5s;
    border-radius: 50%;
   }

  #walt {
    color: white;
    background: #7435af;
    margin: auto;
    border-radius: 20px;
    padding: 20px 10px;
    width: fit-content;
    width: -moz-fit-content;
  }
  .aprovados{
    width: 100%;
    height: auto;
  }
  .titulo_circle{
    text-align: center;
    color:white;
    font-size:30px;
  }
  .imagem{
    width: 50%;
    margin: 0 auto;
  }
  .div_depoimento{
    color: white;
    background: #7435af;
    margin: 40px;
    padding: 10px 30px;
    border-radius: 20px;
  }
  .p_depoimento{
    color:white!important;
  }
  .depoimento img{
    position: relative;
  }
  #fotos_aprovados{
    min-height: 700px;
    height: auto;
    background:#8B658B;
    padding-top:5%;
    /* background: #808A9F; */
  }
  @media only screen and (max-width: 450px) {
    .msgs{
      font-size: 25px;
    }
    #p_depoimentos{
      font-size: 25px;
    }
    .img_aprov{
      width:100%;
    }
    .imagem{
      width: 50%;
      margin: 0 auto;
    }
    #img_aprovados{
      display: block;
    }
    #imag{
      width: 100%;
    }
    .aprov{
      word-break: break-all!important;
      text-align: left;
      width: 100%;
    }
    .aprovados{
      width: 100%;
    }
    .txt_aprovados{
      font-size: 15px;
      color:white;
      justify-content: center;
      display: flex;
    }
    .circle, .titulo_circle{
      font-size: 20px;
    }
 }
</style>
